
/// <amd-module name="Test/TestPlansHubRefresh/TestCasesImportModule/Redux/TestCasesImportPanelContracts" />
export interface ITestCasesImportPanelAwareState {
    testCasesImportPanelState: ITestCasesImportPanelState;
}

export interface ITestCasesImportPanelState {
    csvFileAdded: boolean;
    isLoading: boolean;
    errorMessages: string;
    percentComplete: number;
}
